/**
 * WarningBanner Component
 *
 * A reusable warning banner component for displaying important
 * caution messages to users during the device update process.
 */

import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../shared/Icon';

/**
 * Props for WarningBanner
 */
export interface WarningBannerProps {
  title: string;
  message: string;
}

/**
 * WarningBanner component
 *
 * Displays a yellow warning banner with an icon, title, and message.
 * Used to alert users about important information during device updates.
 */
export const WarningBanner: React.FC<WarningBannerProps> = ({
  title,
  message,
}: WarningBannerProps): React.ReactElement => {
  return (
    <BannerContainer>
      <Icon name='warning' size='medium' color='#1a1a1a' />
      <BannerText>
        <strong>{title}</strong>
        <span>{message}</span>
      </BannerText>
    </BannerContainer>
  );
};

// Styled Components

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #ffc107;
  border-radius: 10px;
  color: #1a1a1a;
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #1a1a1a;

  strong {
    font-size: 14px;
  }

  span {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
  }
`;

export default WarningBanner;